import React from 'react';
import styled from 'styled-components';

const ProgressBar = ({ backgroundColor, progress}) => (
  <Progress 
    backgroundColor={backgroundColor}
    progress={progress}
  />
);

export default ProgressBar;

const Progress = styled.div`
  position: relative;
  width: 350px;
  height: 5px;
  background-color: #eef1fb;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin-top: 15px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => props.progress}%;
    border-radius: 5px;
    background-color: ${props => props.backgroundColor};
  }
`;



// WEBPACK FOOTER //
// ./client/redesign/web/components/ProgressBar/index.js